import { PhotosReceiveApprovedPhotosReducer } from './types';

export const photosReceiveApprovedPhotosReducer: PhotosReceiveApprovedPhotosReducer =
  (state, action) => {
    const { approvedPhotos } = action.payload;

    return {
      ...state,
      approvedPhotos: [...(state.approvedPhotos || []), ...approvedPhotos],
    };
  };
